import { render, staticRenderFns } from "./ReservedList.vue?vue&type=template&id=142b14d4&scoped=true"
import script from "./ReservedList.vue?vue&type=script&lang=js"
export * from "./ReservedList.vue?vue&type=script&lang=js"
import style0 from "./ReservedList.vue?vue&type=style&index=0&id=142b14d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b14d4",
  null
  
)

export default component.exports